import ThisModule from "./PageUserProfile";

export default ThisModule;
